/**
 * Ko'rsatiladigan sahifa raqamlari.
 *
 * Uch yuz sahifani chiqarib bo'lmaydi, shuning uchun chetlari va
 * joriysining atrofi qoladi: `1 … 7 8 9 … 42`. `null` — uzilish.
 */
export function pageNumbers(current: number, total: number): (number | null)[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

  const around = [current - 1, current, current + 1].filter((n) => n > 1 && n < total);
  const shown = [1, ...around, total];

  const result: (number | null)[] = [];
  let previous = 0;
  for (const page of shown) {
    if (page - previous > 1) result.push(null);
    result.push(page);
    previous = page;
  }
  return result;
}
